module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/png/confirm_de-7b04c785a6c84a6cab365452476c8c62.png";